import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d792a26"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  ref: "fullValueBar",
  class: "bar"
};
const _hoisted_2 = {
  key: 0,
  class: "budget-line",
  width: "2",
  height: "20",
  viewBox: "0 0 2 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_3 = ["stroke-dasharray"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "forecast-bar",
    style: _normalizeStyle($options.forecastLength($props.children))
  }, null, 4), _createElementVNode("div", {
    class: "spend-bar",
    style: _normalizeStyle($options.spendLength($props.children))
  }, null, 4), _ctx.aggregateWeeklyBudget($props.children) ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [_createElementVNode("path", {
    d: "M1 1V19",
    stroke: "#1755AB",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-dasharray": $options.budgetLineDashArray($props.children)
  }, null, 8, _hoisted_3)])) : _createCommentVNode("", true)], 512);
}